import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pl-4 align-center" }

import FormRow from "@/components/Common/FormRow.vue"
import createOrUpdateSubManagementOffice from "@/types/requests/createOrUpdateSubManagementOffice"
import { computed } from 'vue';
import { Core as YubinBangoCore } from 'yubinbango-core2';
import i18n from '@/lang/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressForm',
  props: {
    modelValue: {},
    errors: {},
    windowInnerWidth: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

function autoCompleteAddress() {
  const zipCodeValue = `${modelValue.value.zip1}${modelValue.value.zip2}`;
  if (zipCodeValue.match(/^\d{3}-?\d{4}$/)) {
    return new YubinBangoCore(zipCodeValue, (addr: any) => {
      modelValue.value.province = addr.region;
      modelValue.value.address1 = addr.locality + addr.street;
    });
  }
  modelValue.value.province = ''
  modelValue.value.address1 = ''
  modelValue.value.address2 = ''
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "text-form pl-4 pr-3 mb-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 2 : 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.subManagementOffice.form.zipCode')), 1)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: modelValue.value.zip1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.zip1) = $event)),
              maxlength: "3",
              onKeyup: autoCompleteAddress,
              "error-messages": __props.errors?.zipcode
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _: 1
        }),
        _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"height":"50px","line-height":"50px"} }, " - ", -1)),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: modelValue.value.zip2,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.zip2) = $event)),
              maxlength: "4",
              onKeyup: autoCompleteAddress,
              error: __props.errors?.zipcode?.length
            }, null, 8, ["modelValue", "error"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(FormRow, {
      title: _unref(i18n).global.t('pages.subManagementOffice.form.province'),
      windowInnerWidth: props.windowInnerWidth
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: modelValue.value.province,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue.value.province) = $event)),
          "error-messages": props.errors.province,
          maxlength: "255"
        }, null, 8, ["modelValue", "error-messages"])
      ]),
      _: 1
    }, 8, ["title", "windowInnerWidth"]),
    _createVNode(FormRow, {
      title: _unref(i18n).global.t('pages.subManagementOffice.form.address1'),
      windowInnerWidth: props.windowInnerWidth
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: modelValue.value.address1,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue.value.address1) = $event)),
          "error-messages": props.errors.address1,
          maxlength: "255"
        }, null, 8, ["modelValue", "error-messages"])
      ]),
      _: 1
    }, 8, ["title", "windowInnerWidth"]),
    _createVNode(FormRow, {
      title: _unref(i18n).global.t('pages.subManagementOffice.form.address2'),
      windowInnerWidth: props.windowInnerWidth
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: modelValue.value.address2,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modelValue.value.address2) = $event)),
          "error-messages": props.errors.address2,
          maxlength: "255"
        }, null, 8, ["modelValue", "error-messages"])
      ]),
      _: 1
    }, 8, ["title", "windowInnerWidth"])
  ], 64))
}
}

})